import React from "react";

interface InfoItemProps {
  label: string;
  value: React.ReactNode;
  className?: string;
}

export const InfoItem: React.FC<InfoItemProps> = ({ label, value, className = "" }) => (
  <div className={className}>
    <dt className="text-sm font-medium text-slate-500 mb-1">{label}</dt>
    <dd className="text-base text-slate-800 break-all">{value || "-"}</dd>
  </div>
);
